import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

import { LESSON_MESSAGES } from "../../messages";

interface ContinueButtonProps {
    onClick: () => void;
    colorClassName: string; // e.g. "bg-green-600 hover:bg-green-500"
}

// The big "Continue" button shared by the lesson-complete and streak screens
const ContinueButton = ({ onClick, colorClassName }: ContinueButtonProps) => (
    <button
        type="button"
        onClick={onClick}
        className={classNames(
            "flex w-full items-center justify-center gap-2 rounded-2xl py-4 text-lg font-bold text-white shadow-lg transition active:scale-95",
            colorClassName
        )}
    >
        {LESSON_MESSAGES.continue}
        {/* The arrow points forward: left in Persian, right in English */}
        <FontAwesomeIcon icon={faArrowLeft} className="ltr:rotate-180" />
    </button>
);

export default ContinueButton;